// Resolves the backend API base URL.
// REACT_APP_API_URL may hold a comma-separated list, e.g.
//   http://10.10.5.33:8010,https://api.ek-library.ekbana.ai
// We pick one based on how the page itself is being accessed:
//   - LAN/IP/localhost page  -> the http:// (LAN) backend
//   - public domain page     -> the https:// (public) backend
export function resolveApiUrl(): string {
  const raw = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const urls = raw
    .split(',')
    .map((u) => u.trim())
    .filter(Boolean);

  if (urls.length <= 1) {
    return urls[0] || 'http://localhost:8000';
  }

  const host = window.location.hostname;
  const isLan = /^\d+\.\d+\.\d+\.\d+$/.test(host) || host === 'localhost';

  // 1) exact hostname match wins
  const exact = urls.find((u) => {
    try {
      return new URL(u).hostname === host;
    } catch {
      return false;
    }
  });
  if (exact) return exact;

  // 2) otherwise pick by protocol intent
  const wantHttps = !isLan;
  const byProto = urls.find((u) => u.startsWith(wantHttps ? 'https://' : 'http://'));

  return byProto || urls[0];
}

export const API_URL = resolveApiUrl();
